export default __webpack_public_path__ + "static/media/ec.72873e2c.svg";